/* ========== OOXML NAMESPACE URIS ==========
 * Used wherever DOM lookups require the full namespace name (e.g.
 * getAttributeNS for r:id).
 * =========================================== */

export const REL_NS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships";
